import script from "./ProjectExportDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectExportDialog.vue?vue&type=script&setup=true&lang=js"

import "./ProjectExportDialog.vue?vue&type=style&index=0&id=664d8900&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-664d8900"]])

export default __exports__